<dms-control [dmsTraduction]="dmsTraduction" >
	<button class="btn btn-primary" type="button" style="width:50%" (click)="openSignatureModal()" ><i class="fa fa-pencil-square-o"></i>{{ dmsTraduction }}</button>
	<span style="margin-left:10%">
		<i class="fa fa-times" id="alreadyDone" style="color:red"></i>
	</span>
</dms-control>